const testimonials = [
  {
    image:
      "https://readdy.ai/api/search-image?query=Premium%20click%20PVC%20flooring%20herringbone%20pattern%20installed%20in%20modern%20living%20room%20warm%20oak%20look%20natural%20light%20clean%20minimalist%20interior%20photography%20high%20quality",
    badge: "Gerealiseerd",
    rating: 5,
    review:
      '"Onze woonkamer is compleet getransformeerd! De visgraat PVC vloer ziet er zo luxe uit dat iedereen denkt dat het echt hout is. Het team werkte netjes en professioneel."',
    project: "Woonkamer 42m² • PVC Visgraat",
    name: "Sophie van Dijk",
    location: "Amsterdam",
    avatar:
      "https://readdy.ai/api/search-image?query=professional-dutch-woman-smiling-portrait-natural-light-warm-friendly-expression-brown-hair-home-interior-background",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=Glue%20down%20PVC%20flooring%20waterproof%20installation%20in%20modern%20bathroom%20grey%20slate%20look%20clean%20minimalist%20interior%20photography%20high%20quality",
    badge: "Gerealiseerd",
    rating: 5,
    review:
      '"Perfecte service van begin tot eind. Gratis adviesgesprek, duidelijke offerte, en vakkundig geplaatst. De vloer in de badkamer is waterdicht en prachtig."',
    project: "Badkamer 18m² • PVC Lijm Grijs",
    name: "Mark Jansen",
    location: "Amstelveen",
    avatar:
      "https://readdy.ai/api/search-image?query=professional-dutch-man-smiling-portrait-natural-light-confident-expression-short-dark-hair-modern-office-background",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=Wide%20plank%20laminate%20flooring%20light%20oak%20installed%20in%20modern%20open%20plan%20living%20space%20natural%20light%20clean%20minimalist%20interior%20photography%20high%20quality",
    badge: "Gerealiseerd",
    rating: 5,
    review:
      '"Geweldige kwaliteit voor een eerlijke prijs. De laminaat vloer ligt er nu 2 jaar en ziet er nog steeds uit als nieuw. Zelfs met twee kinderen en een hond!"',
    project: "Woning 85m² • Laminaat Breed Plank",
    name: "Lisa Bakker",
    location: "Haarlem",
    avatar:
      "https://readdy.ai/api/search-image?query=professional-dutch-woman-smiling-portrait-natural-light-warm-friendly-expression-red-hair-contemporary-interior-background",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=Seamless%20polyurethane%20poured%20floor%20gietvloer%20in%20modern%20minimalist%20apartment%20matte%20grey%20finish%20clean%20lines%20natural%20light%20interior%20photography%20high%20quality",
    badge: "Gerealiseerd",
    rating: 5,
    review:
      '"De gietvloer is echt een eyecatcher geworden. Iedereen die binnenkomt is onder de indruk. Naadloos, modern en heel makkelijk schoon te houden. Top vakmanschap!"',
    project: "Appartement 65m² • PU Gietvloer",
    name: "Thomas de Vries",
    location: "Zaandam",
    avatar:
      "https://readdy.ai/api/search-image?query=professional-dutch-man-smiling-portrait-natural-light-friendly-expression-glasses-modern-home-background",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=Modern%20apartment%20with%20PVC%20click%20flooring%20warm%20wood%20look%20living%20room%20kitchen%20hallway%20open%20plan%20natural%20light%20interior%20photography%20high%20quality",
    badge: "Gerealiseerd",
    rating: 5,
    review:
      '"Binnen een week van offerte tot gelegde vloer. Communicatie was helder, prijs zoals afgesproken, en het resultaat is prachtig. Aanrader voor iedereen!"',
    project: "Woning 55m² • PVC Click Licht Eiken",
    name: "Emma Visser",
    location: "Diemen",
    avatar:
      "https://readdy.ai/api/search-image?query=professional-dutch-woman-smiling-portrait-natural-light-warm-friendly-expression-blonde-hair-modern-office-background",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=Modern%20kitchen%20with%20waterproof%20PVC%20flooring%20grey%20tile%20look%20underfloor%20heating%20comfortable%20warm%20atmosphere%20interior%20photography%20high%20quality",
    badge: "Gerealiseerd",
    rating: 5,
    review:
      '"Fantastische ervaring! De adviseur nam echt de tijd om alle opties door te nemen. De installateurs waren netjes, snel en heel efficiënt. Vloerverwarming werkt perfect."',
    project: "Keuken 22m² • PVC + Vloerverwarming",
    name: "Jeroen Peters",
    location: "Aalsmeer",
    avatar:
      "https://readdy.ai/api/search-image?query=professional-dutch-man-smiling-portrait-natural-light-confident-expression-beard-modern-interior-background",
  },
];

export default function TestimonialsSection() {
  return (
    <section className="py-16 sm:py-20 bg-ink-900 rounded-t-[2rem] sm:rounded-t-[3rem] rounded-b-[2rem] sm:rounded-b-[3rem]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-16">
          <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-2 bg-brass-500/10 rounded-full border border-brass-500/20 mb-4 sm:mb-6">
            <i className="ri-star-fill text-brass-500 text-sm"></i>
            <span className="text-xs sm:text-sm font-medium text-brass-500">4.9/5 Gemiddeld</span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-light text-white mb-3 sm:mb-4">
            Wat onze klanten <span className="font-medium text-brass-500">zeggen</span>
          </h2>
          <p className="text-sm sm:text-base text-white/70 max-w-2xl mx-auto">
            Meer dan 2.400 tevreden klanten gingen je voor. Lees hun ervaringen en ontdek waarom zij voor ons kozen.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5 lg:gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="group transition-all duration-700"
              itemScope
              itemType="https://schema.org/Review"
            >
              <div className="bg-white/5 backdrop-blur-sm rounded-2xl overflow-hidden border border-white/10 hover:border-brass-500/50 transition-all duration-300 hover:shadow-2xl h-full flex flex-col">
                <div className="relative h-40 sm:h-48 overflow-hidden">
                  <img
                    alt={`${t.project} - ${t.location}`}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    loading="lazy"
                    src={t.image}
                    width={600}
                    height={400}
                  />
                  <div className="absolute top-3 sm:top-4 right-3 sm:right-4 bg-brass-500 text-white px-2.5 sm:px-3 py-0.5 sm:py-1 rounded-full text-xs font-semibold">
                    {t.badge}
                  </div>
                </div>
                <div className="p-4 sm:p-6 flex-1 flex flex-col">
                  <div className="flex items-center gap-1 mb-3 sm:mb-4">
                    {Array.from({ length: t.rating }).map((_, ri) => (
                      <i key={ri} className="ri-star-fill text-brass-500 text-sm sm:text-base"></i>
                    ))}
                  </div>
                  <p className="text-white/90 text-xs sm:text-sm leading-relaxed mb-4 sm:mb-6 flex-1">
                    {t.review}
                  </p>
                  <div className="bg-white/5 rounded-xl p-2.5 sm:p-3 mb-3 sm:mb-4 border border-white/10">
                    <p className="text-xs sm:text-sm text-brass-500 font-semibold">{t.project}</p>
                  </div>
                  <div className="flex items-center gap-3 sm:gap-4">
                    <div className="relative">
                      <img
                        alt={t.name}
                        className="w-10 h-10 sm:w-14 sm:h-14 rounded-full object-cover border-2 border-brass-500/30"
                        loading="lazy"
                        src={t.avatar}
                        width={64}
                        height={64}
                      />
                      <div className="absolute -bottom-0.5 -right-0.5 w-4 h-4 sm:w-6 sm:h-6 bg-brass-500 rounded-full flex items-center justify-center border-2 border-ink-900">
                        <i className="ri-check-line text-white text-[8px] sm:text-xs"></i>
                      </div>
                    </div>
                    <div>
                      <p className="font-bold text-white text-xs sm:text-sm">{t.name}</p>
                      <p className="text-[10px] sm:text-xs text-white/60 flex items-center gap-1">
                        <i className="ri-map-pin-line text-brass-500"></i>
                        {t.location}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10 sm:mt-16">
          <p className="text-white/70 mb-4 sm:mb-6 text-sm sm:text-base">
            Sluit je aan bij duizenden tevreden klanten
          </p>
          <a
            href="#offerte"
            className="inline-flex items-center gap-2 bg-brass-500 hover:bg-brass-600 text-white px-6 sm:px-8 py-3.5 sm:py-4 rounded-xl font-bold hover:scale-105 hover:shadow-xl transition-all duration-300 whitespace-nowrap text-sm sm:text-base"
          >
            Start jouw project
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}